import { Grid2, Show, Tab, Tabs } from "components";
import { lazy } from "react";
import { TAB } from "store/slices/appSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { UserRoleTypes } from "utils/common";
import useDocumentTitle from "utils/useDocumentTitle";

// Lazy load tab components with React 19's improved lazy loading
const BrokerIntegration = lazy(
  () => import("../ReportsPages/BrokerIntegration"),
);
const AutoImportTab = lazy(() => import("./AutoImportTab"));
const ContractNotes = lazy(() => import("./ContractNotes"));

const PortfolioUtilityEdit = () => {
  useDocumentTitle("Portfolio Import");

  const dispatch = useAppDispatch();
  const userData = useAppSelector((state) => state?.user?.userData);
  const { portfolioUtilityTabs } = useAppSelector((state) => state?.app?.tab);

  // React 19: Using useTransition for smoother tab switching

  const handleTabChange = (e: React.SyntheticEvent, val: number) => {
    dispatch(TAB({ tabKey: "portfolioUtilityTabs", tabValue: val }));
  };

  return (
    <Grid2 container spacing={1}>
      <Grid2 size={12} display={"flex"}>
        <Tabs
          className="light"
          variant="standard"
          TabIndicatorProps={{ style: { display: "none" } }}
          value={portfolioUtilityTabs}
          onChange={handleTabChange}
        >
          <Tab label="Manual Import" disableRipple />
          <Tab label="Auto Import" disableRipple />
          {userData?.userRole !== UserRoleTypes.client && (
            <Tab label="Broker Integration" disableRipple />
          )}
        </Tabs>
      </Grid2>

      <Grid2 size={12}>
        <Show.When isTrue={portfolioUtilityTabs === 0}>
          <ContractNotes />
        </Show.When>
        <Show.When isTrue={portfolioUtilityTabs === 1}>
          <AutoImportTab />
        </Show.When>
        <Show.When isTrue={portfolioUtilityTabs === 2}>
          <BrokerIntegration />
        </Show.When>
      </Grid2>
    </Grid2>
  );
};

export default PortfolioUtilityEdit;
